import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import PROVIDER_CONFIG from "./provider_config";

class Weight extends Component {
  render() {
    return <Menu {...PROVIDER_CONFIG} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: {
      ...state.intl.messages.containers.features.weight,
      components: {
        calorieCalculator: state.intl.messages.components.calorieCalculator,
        bodyConditionScore: state.intl.messages.components.bodyConditionScore,
      },
    },
    weight: state.reducers.weight,
    userPreferredUnit:
      state.reducers.contacts.selectedContact._user.featurePreferences
        .weightUnit,
    providerContact: { _id: state.reducers.pets.selectedPet._user },
  };
};

export default connect(mapStateToProps)(Weight);
